import React, { createContext, useContext, useState, useEffect } from 'react';
import { fetchApi } from '../lib/utils';

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(localStorage.getItem('vyta_token'));

  useEffect(() => {
    const initAuth = async () => {
      if (token) {
        try {
          const userData = await fetchApi('/auth/me');
          setUser(userData);
        } catch (error) {
          console.error('Auth init error:', error);
          localStorage.removeItem('vyta_token');
          setToken(null);
        }
      }
      setLoading(false);
    };

    initAuth();
  }, [token]);

  const login = async (email, password) => {
    const response = await fetchApi('/auth/login', {
      method: 'POST',
      body: JSON.stringify({ email, password }),
    });
    
    localStorage.setItem('vyta_token', response.access_token);
    setToken(response.access_token);
    setUser(response.user);
    return response.user;
  };

  const register = async (name, email, password, additionalData = {}) => {
    const response = await fetchApi('/auth/register', {
      method: 'POST',
      body: JSON.stringify({ name, email, password, ...additionalData }),
    });
    
    localStorage.setItem('vyta_token', response.access_token);
    setToken(response.access_token);
    setUser(response.user);
    return response.user;
  };

  const logout = () => {
    localStorage.removeItem('vyta_token');
    setToken(null);
    setUser(null);
  };

  const updateUser = (userData) => {
    setUser(prev => ({ ...prev, ...userData }));
  };

  const value = {
    user,
    token,
    loading,
    login,
    register,
    logout,
    updateUser,
    isAuthenticated: !!user,
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
